import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { common } from '@ocean/ui'

const { Icon } = common

export const Root = styled.div`
  cursor: pointer;
`

export const IconWrapper = styled.div`
  padding-top: 4px;

  ${media.sm`
    padding-top: 7px;
  `}
`

export const IconFlag = styled(Icon)`
  width: 10px;
  height: 12px;

  > path {
    stroke: ${({ theme }) => theme.color.gold};
  }

  ${media.sm`
    width: 13px;
    height: 16px;
  `}
`
